<template>
  <g>
    <path
      d="M4.4955 7.44092C3.54724 8.11791 2.77843 8.8418 2.1893 9.47982C0.857391 10.9222 0.857392 13.0778 2.1893 14.5202C3.9167 16.391 7.18879 19 12 19C13.2958 19 14.4799 18.8108 15.5523 18.4977L13.8895 16.8349C13.2936 16.9409 12.6638 17 12 17C7.9669 17 5.18832 14.82 3.65868 13.1634C3.03426 12.4872 3.03426 11.5128 3.65868 10.8366C4.23754 10.2097 4.99526 9.50788 5.93214 8.87757L4.4955 7.44092Z"
    />
    <path
      d="M8.53299 11.4785C8.50756 11.6487 8.49438 11.8228 8.49438 12.0001C8.49438 13.9331 10.0614 15.5001 11.9944 15.5001C12.1716 15.5001 12.3458 15.4869 12.516 15.4615L8.53299 11.4785Z"
    />
    <path
      d="M15.4661 12.4471L11.5473 8.52829C11.6937 8.50962 11.8429 8.5 11.9944 8.5C13.9274 8.5 15.4944 10.067 15.4944 12C15.4944 12.1515 15.4848 12.3007 15.4661 12.4471Z"
    />
    <path
      d="M18.1118 15.0928C19.0284 14.4702 19.7715 13.7805 20.3413 13.1634C20.9657 12.4872 20.9657 11.5128 20.3413 10.8366C18.8117 9.18002 16.0331 7 12 7C11.3594 7 10.7505 7.05499 10.1732 7.15415L8.50482 5.48582C9.56209 5.1826 10.7272 5 12 5C16.8112 5 20.0833 7.60905 21.8107 9.47978C23.1426 10.9222 23.1426 13.0778 21.8107 14.5202C21.2305 15.1486 20.476 15.8603 19.5474 16.5284L18.1118 15.0928Z"
    />
    <path
      d="M2.00786 3.42195C1.61733 3.03143 1.61733 2.39826 2.00786 2.00774C2.39838 1.61721 3.03155 1.61721 3.42207 2.00774L22.0004 20.5861C22.391 20.9766 22.391 21.6098 22.0004 22.0003C21.6099 22.3908 20.9767 22.3908 20.5862 22.0003L2.00786 3.42195Z"
    />
  </g>
</template>
